

function Header(props) {
    return <header className="App-header">
        <img src={props.logo} className="logo" alt="logo" />
        Credit Card Buddy
    </header>;
}

export default Header;